module.exports = __webpack_public_path__ + "img/file.9ed5e90e.svg";